(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-sub"]) return;
  try {
    
(function() {
  function init(block) {
    if (block.dataset.spInit) return;
    block.dataset.spInit = '1';

    var cards = block.querySelectorAll('input.sp-plan__input');
    var realOnetime = block.querySelector('input[name="selling_plan_group"][value=""]:not([data-enable*="-"])')
                  || block.querySelector('input[name="selling_plan_group"][data-enable=""]')
                  || block.querySelector('input#purchase_option_single-' + CSS.escape(block.getAttribute('data-sp-block')));

    function fire(el) {
      if (!el) return;
      el.checked = true;
      el.dispatchEvent(new Event('change', { bubbles: true }));
      el.dispatchEvent(new Event('click', { bubbles: true }));
    }

    function applyCard(card) {
      if (!card) return;
      var variantId = card.getAttribute('data-sp-variant-id');
      if (variantId) {
        document.querySelectorAll('input[name="id"]').forEach(function(input) {
          input.value = variantId;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      block.querySelectorAll('input[name="selling_plan"]').forEach(function(r) { r.checked = false; });
      if (realOnetime) fire(realOnetime);
    }

    cards.forEach(function(card) {
      card.addEventListener('change', function() {
        if (card.checked) applyCard(card);
      });
    });

    var initial = block.querySelector('input.sp-plan__input:checked') || cards[0];
    if (initial) {
      initial.checked = true;
      applyCard(initial);
    }
  }

  function boot() {
    document.querySelectorAll('[data-sp-block]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faq"] && !Shopify.designMode) return;
  try {
     
  const accordionOpener = document.querySelectorAll(".accordion-a .details summary");
  accordionOpener.forEach(function(element) {
    element.addEventListener("click", function() {
      this.parentNode.classList.toggle("open");
    });
  }
  );

  } catch(e) { console.error(e); }
})();
})();
